import React, { ReactElement, useContext } from 'react';
import { AppContext } from '../../../../state/app.state';
import Flag from './Flag';


const FlagCollection: React.FC = (): ReactElement => {
    const { state, presentationState } = useContext(AppContext);

    return (
        <>
            {!presentationState?.activePreview && state?.currentView?.flags.simple.map(flag => <Flag flag={flag} className={'bv-mapping-fade-in'} key={flag.id} />)}
            {!presentationState?.activePreview && state?.currentView?.flags.views.map(flag => {
                const inactive = !state.project?.views.find(v => v.id === flag.mappingEntityId);

                return <Flag
                    flag={flag}
                    className={inactive ? 'bv-flag-inactive bv-mapping-fade-in' : 'bv-mapping-fade-in'}
                    key={flag.id}
                    onMouseOver={():void => {
                        if (inactive) return;
                        flag.mappingEntityId && state.setPreviewObjectId(flag.mappingEntityId);
                    }}
                    onMouseOut={(): void => {
                        if (inactive) return;
                        state.setPreviewObjectId(undefined);
                    }}
                    onClick={():void => {
                        if (inactive) return;
                        state.setPreviewObjectId(undefined);
                        state.changeView(flag.mappingEntityId);
                    }}/>;
            })}
        </>

    );
};


export default FlagCollection;